import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';

interface CommonStateModel {
  loading: boolean;
}

@State<CommonStateModel>({
  name: 'common',
  defaults: {
    loading: false,
  },
})
@Injectable()
export class CommonState {

  @Selector()
  static loading(state: CommonStateModel): boolean {
    return state.loading;
  }

  @Action([])
  stopLoading(ctx: StateContext<CommonStateModel>): void {
    ctx.patchState({ loading: false });
  }
}

